var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-wrapper",on:{"click":_vm.changeActive}},[_c('div',{staticClass:"switch",class:[{ 'switch-active': _vm.active }, { 'locale-usa': _vm.locale === 'USA' }]}),_c('div',{staticClass:"switch-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }